import { z } from 'zod';
/**
 * The studio's usage and cost report: what was produced, what it consumed and
 * what that cost at the prices set on each connector. Every figure is an
 * estimate (see generationPricing.ts), and a job with no price is counted in
 * `unknownPriceJobs` rather than as zero.
 */
export const GENERATION_STATS_GROUPS = ['day', 'week', 'month'];
/** `from` / `to`: ISO dates or date-times. A date-only `to` includes that whole day (UTC). Default: the last 30 days. */
export const generationStatsQuerySchema = z.object({
    from: z.string().trim().min(8).max(40).optional(),
    to: z.string().trim().min(8).max(40).optional(),
    groupBy: z.enum(GENERATION_STATS_GROUPS).default('day'),
});
//# sourceMappingURL=generationStats.js.map